"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.redefinePublicPath = void 0;
const redefinePublicPath = () => {
  // We don't support setting public path in webpack via NPM build.
};
exports.redefinePublicPath = redefinePublicPath;